export function resolveAppOrigin(configuredUrl: string | undefined, browserOrigin: string): string {
  const candidate = configuredUrl?.trim() || browserOrigin;
  let url: URL;
  try {
    url = new URL(candidate);
  } catch {
    throw new Error("VITE_APP_URL must be a valid absolute URL");
  }

  const isSecureCloudUrl = url.protocol === "https:";
  const isLocalDevelopmentUrl = url.protocol === "http:" && url.hostname === "localhost";
  if (!isSecureCloudUrl && !isLocalDevelopmentUrl) {
    throw new Error("VITE_APP_URL must use HTTPS or http://localhost");
  }
  if (url.username || url.password) {
    throw new Error("VITE_APP_URL must not contain credentials");
  }

  return url.origin;
}

const browserOrigin = typeof window === "undefined" ? "http://localhost" : window.location.origin;

export const appOrigin = resolveAppOrigin(import.meta.env.VITE_APP_URL, browserOrigin);
